import * as Yup from 'yup';

export const CourseValidationSchema = Yup.object().shape({
  nm_comarca: Yup.string().trim().required('O campo Nome é obrigatório.'),
});
